import { Outlet } from 'react-router';
import { ThemeProvider } from 'styled-components';

import { ErrorBoundary } from './containers/ErrorBoundary';
import { ModalRoot } from './containers/Modal/ModalRoot';
import { TabContextProvider } from './containers/TabContext';
import { ToastsContainer } from './containers/ToastsContainer';
import { GlobalHandlers } from './global-handlers/GlobalHandlers';
import { AuthTmpStorageContextProvider } from './modules/auth/context/AuthTmpStorageContext';
import { SearchContextProvider } from './modules/search/contexts/SearchContext';
import { SavedSearchesContextProvider } from './modules/userDashboard/contexts/SavedSearchesContext';
import { themeContextValue } from './theme/theme';

export function App() {
  return (
    <ThemeProvider theme={themeContextValue}>
      <ErrorBoundary>
        <SearchContextProvider>
          <GlobalHandlers />
          <SavedSearchesContextProvider>
            <AuthTmpStorageContextProvider>
              <TabContextProvider>
                <ModalRoot />
                <ToastsContainer />
                <Outlet />
              </TabContextProvider>
            </AuthTmpStorageContextProvider>
          </SavedSearchesContextProvider>
        </SearchContextProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
